import React, { Component } from "react";
 
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= 400,
      loadedImages: new Set()
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth <= 400
    });
  }

  handleImageLoad = (imageUrl) => {
    this.setState(prevState => ({
      loadedImages: new Set(prevState.loadedImages).add(imageUrl)
    }));
  }

  render() {
      const { isMobile, loadedImages } = this.state;
      const formatParam = isMobile ? "?format=100w" : "?format=2500w";
      
      const x_home =   "https://images.squarespace-cdn.com/content/53667a41e4b0e77173cb3dd1/1e6a3bf2-30fd-4f29-8bd5-2d050b4e57b8/Henri+Alexander+Levy+Webiste+-+Cover+Page+Image+%2808-22%29+copy.png?content-type=image%2Fpng";
      const alt_2_home = "https://images.squarespace-cdn.com/content/53667a41e4b0e77173cb3dd1/a7d0792b-ec14-41bc-8194-e2359d721320/9134-21a.JPG?content-type=image%2Fjpeg";
      const og_home = "https://static1.squarespace.com/static/5ad4d6c7a2772c84c876a433/5d9bfe1d891ec13e8f7d9642/5d9bfe3c3dc97713cd08faa3/1570504266192/WEBSITE+COVER+PHOTO.TIF.png";
      const show_info = "https://images.squarespace-cdn.com/content/53667a41e4b0e77173cb3dd1/94988cb5-1c67-4d31-b102-96c975c48314/Russia+Show+Info.jpg?content-type=image%2Fjpeg";
      
      return (
      <div className="home-page">
        <div className="image-container">
          <img
            src={`${x_home}${formatParam}`}
            alt=""
            className={`home-img ${loadedImages.has(`${x_home}${formatParam}`) ? 'loaded' : 'loading'}`}
            onLoad={() => this.handleImageLoad(`${x_home}${formatParam}`)}
          />
        </div>
        <br></br>
        <div className="image-container">
          {/* <img
            src={`${show_info}${formatParam}`}
            alt=""
            className={`show-details ${loadedImages.has(`${show_info}${formatParam}`) ? 'loaded' : 'loading'}`}
            style={{
              width: '60%',
            }}
            onLoad={() => this.handleImageLoad(`${show_info}${formatParam}`)}
          /> */}
        </div>
      </div>
    );
  }
}

export default Home;